/**
 * 시스템 관리자 대시보드
 */

import React from 'react';
import { Card, Typography, Space, Descriptions } from 'antd';
import { useAuth } from '../../hooks/useAuth';
import { getRoleLabel } from '../../components/layout/menuConfig';

const { Title, Text } = Typography;

export const SystemDashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Card>
        <Title level={2}>시스템 관리자 대시보드</Title>
        <Text type="secondary">
          모든 그룹을 관리하고 시스템 전체를 모니터링할 수 있습니다.
        </Text>
      </Card>

      <Card title="관리자 정보">
        <Descriptions column={1} bordered>
          <Descriptions.Item label="이름">{user?.name}</Descriptions.Item>
          <Descriptions.Item label="이메일">{user?.email}</Descriptions.Item>
          <Descriptions.Item label="역할">{user ? getRoleLabel(user.role) : '-'}</Descriptions.Item>
          <Descriptions.Item label="활성 상태">
            {user?.is_active ? '✅ 활성' : '❌ 비활성'}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card>
        <Text type="warning">
          ⚠️ 향후 기능: 그룹 관리, 사용자 관리, 시스템 통계 등
        </Text>
      </Card>
    </Space>
  );
};

export default SystemDashboard;
